export function isName(name: string) {
  const validateName = /^(?!\\s*$)[^!@#$%^*:;?><\\/~{}+_|]+$/;
  return validateName.test(name);
}
